const defaultState = {
    error: null,
    fetching: false,
    fetched: false,
    myActivity: null
};

const getMyActivityReducer = (state = defaultState, action) => {
    switch (action.type) {
        case 'MY_ACTIVITY_FETCH_PENDING': {
            return {
                ...state, error: null, fetching: true
            };
        }
        case 'MY_ACTIVITY_FETCH_FULFILLED': {
            return {
                ...state,
                error: null,
                fetching: false,
                fetched: true,
                myActivity: action.payload.data
            };
        }
        case 'MY_ACTIVITY_FETCH_REJECTED': {
            return {
                ...state,
                error: action.payload,
                fetching: false,
                fetched: false,
                myActivity: null,
            };
        }
        default:
            break;
    }

    return state;
};

export default getMyActivityReducer;


// WEBPACK FOOTER //
// ./src/reducers/getMyActivity.js